/**
 * kult-pdp.js
 * Web Component <kult-pdp-buybox>: Varianten-Matcher (Größe x Zubereitung),
 * Live-Preis, Grundpreis (aus unit_price, nicht aus Gewicht berechnet),
 * Grind-Hint, Rechtstext, Versandbalken, Mengenrechner mit Kult-Club-
 * Jahreshochrechnung (13 Lieferungen, Statuswechsel simuliert) und
 * Add-to-Cart per fetch. Datenquelle: <script data-pdp-config> im Snippet
 * snippets/kult-pdp-buybox.liquid. Keine Storage-Zugriffe, keine externen Libs.
 * Kult Club nach kg (09.10.2026): Im Abo ersetzt der Mengenregler (500–3.000 g, 250-g-Schritte,
 * snippets/kult-pdp-abo-menge.liquid) die Größen-Pills; Rechnung in assets/kult-abo-calc.js (window.KultAboCalc).
 * Warenkorb: je Beutelgröße eine Zeile mit demselben selling_plan, Eigenschaft _kultabo_set (eine ID je Klick)
 * und an der ersten Zeile „Abo-Menge“. Einzelkauf: Mengenvorteil gegenüber 250-g-Beuteln und Versandlücke in €
 * mit den Beutelgrößen, die sie schließen (Grenze aus snippets/kult-versand-werte.liquid).
 * Menge-Block (11.10.2026): Stückzahl 1–99 nur über button[data-step]; Abo → Einmalig setzt Stückzahl 1 und die Größe
 * zum Regler (gleich, sonst nächstgrößere, sonst größte), Einmalig → Abo den Regler auf die gewählte Größe (min. 500 g).
 */
(function () {
  'use strict';

  var priceFormatter = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });

  function formatPrice(cents) {
    return priceFormatter.format((cents || 0) / 100);
  }

  /* Grenzen ohne „,00“ (Design-Audit 16.10.2026: „ab 45 €“ statt „ab 45,00 €“, wie Kopfleiste) */
  function formatLimit(cents) {
    return formatPrice(cents).replace(/,00(\s?€)/, '$1');
  }

  function isWholeBeanValue(value) {
    var down = (value || '').toLowerCase();
    return down.indexOf('bohne') > -1 || down.indexOf('sieb') > -1 || down.indexOf('vollautomat') > -1;
  }

  /* Anzeige-Label des Mahlgrads (Handfilter → Filter, Herdkanne → Espressokocher; assets/kult-grind.js, 10.10.2026) */
  function grindLabel(value) {
    return window.KultGrind ? window.KultGrind.label(value) : String(value || '');
  }

  function methodKeyFromGrindValue(value) {
    var down = (value || '').toLowerCase();
    if (down.indexOf('handfilter') > -1) return 'handfilter';
    if (down.indexOf('french') > -1) return 'frenchpress';
    if (down.indexOf('herdkanne') > -1) return 'herdkanne';
    if (down.indexOf('sieb') > -1) return 'siebtraeger';
    if (down.indexOf('vollautomat') > -1) return 'vollautomat';
    return null;
  }

  /* „250 g“, „0,5 kg“, „1 kg“ → Gramm (umbenannte Labels setzen die Rechnung nicht auf 0) */
  function gramsFromLabel(label) {
    var m = String(label || '').replace(',', '.').match(/([\d.]+)\s*(kg|g)\b/i);
    if (!m) return null;
    var n = parseFloat(m[1]);
    return m[2].toLowerCase() === 'kg' ? Math.round(n * 1000) : Math.round(n);
  }

  function initBuybox(root) {
    var configEl = root.querySelector('[data-pdp-config]');
    if (!configEl) return;

    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }

    var variants = config.variants || [];
    var sizeOptionIndex = typeof config.sizeOptionIndex === 'number' ? config.sizeOptionIndex : -1;
    var grindOptionIndex = typeof config.grindOptionIndex === 'number' ? config.grindOptionIndex : -1;
    var threshold = typeof config.threshold === 'number' ? config.threshold : 45;   /* 0 = immer versandfrei (Gold: 25 €, Einzelkauf und Abo) */

    var form = root.querySelector('[data-product-form]');
    var idInput = root.querySelector('[data-product-id]');
    var quantityInput = root.querySelector('[data-quantity-input]');
    var qtyValueEl = root.querySelector('[data-qty-value]');
    var priceEl = root.querySelector('[data-price-current]');
    var unitPriceEl = root.querySelector('[data-unit-price]');
    var grindHintEl = root.querySelector('[data-grind-hint]');
    var legalGrindEl = root.querySelector('[data-legal-grind]');
    var legalSizeEl = root.querySelector('[data-legal-size]');
    var shippingBar = root.querySelector('[data-shipping-bar]');
    var shippingText = root.querySelector('[data-shipping-text]');
    var shippingIconDefault = root.querySelector('[data-shipping-icon-default]');
    var shippingIconDone = root.querySelector('[data-shipping-icon-done]');
    var submitBtn = root.querySelector('[data-submit-btn]');
    var buybar = root.querySelector('[data-buybar]');
    var buybarBtn = null;
    /* Preis-Element vor dem Verschieben an body merken (danach findet root.querySelector es nicht mehr, UX-Review B1) */
    var buybarPrice = buybar ? buybar.querySelector('[data-buybar-price]') : null;
    var buybarGrind = buybar ? buybar.querySelector('[data-buybar-grind]') : null;
    if (buybar && submitBtn && 'IntersectionObserver' in window) {
      // Ans Ende des Body hängen: Reveal-Transforms der Vorfahren würden position:fixed sonst aushebeln
      document.body.appendChild(buybar);
      buybar.hidden = false;
      buybar.classList.add('is-hidden');
      buybarBtn = buybar.querySelector('[data-buybar-btn]');
      var barIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          // Haupt-Kauf-Button ist oben aus dem Viewport gescrollt (top < 0) und
          // nicht mehr sichtbar: Leiste einblenden. Solange der Button selbst
          // sichtbar ist, bleibt die Leiste ausgeblendet.
          var scrolledPastTop = e.boundingClientRect.top < 0;
          var shouldShow = scrolledPastTop && !e.isIntersecting;
          buybar.classList.toggle('is-hidden', !shouldShow);
        });
      }, { threshold: 0 });
      barIo.observe(submitBtn);
      if (buybarBtn) buybarBtn.addEventListener('click', function () { submitBtn.click(); });
    }
    var errorEl = root.querySelector('[data-form-error]');

    /* Kult Club nach kg: Abo-Mengenregler (nur Kaffee mit Größen-Option und geladenem kult-abo-calc.js) */
    var Calc = window.KultAboCalc || null;
    var aboBox = root.querySelector('[data-abo-menge]');
    var aboOn = !!(Calc && aboBox && sizeOptionIndex > -1);
    var aboMin = aboOn ? (parseInt(aboBox.getAttribute('data-min'), 10) || 500) : 500;
    var aboMax = aboOn ? (parseInt(aboBox.getAttribute('data-max'), 10) || 3000) : 3000;
    var aboStep = aboOn ? (parseInt(aboBox.getAttribute('data-step-g'), 10) || 250) : 250;
    var aboGrams = aboMin;
    var aboValueEl = aboOn ? aboBox.querySelector('[data-abo-value]') : null;
    var aboBagsEl = aboOn ? aboBox.querySelector('[data-abo-bags]') : null;
    var aboShipEl = aboOn ? aboBox.querySelector('[data-abo-ship]') : null;
    var aboPerKgEl = aboOn ? aboBox.querySelector('[data-abo-perkg]') : null;
    var sizeGroupEl = root.querySelector('[data-variant-group="size"]');
    var sizeSavingEl = root.querySelector('[data-size-saving]');
    /* Kaffee: Stückzahl-Zeile im Menge-Block (data-qty-row), Zubehör/Probierset: nur der Stepper */
    var qtyStepperEl = root.querySelector('[data-qty-row]') || root.querySelector('.kult-buy-widget__stepper');
    var QTY_MAX = 99;

    // Kaufoption Einmalkauf/Kult-Club (Abo), siehe kult-pdp-purchase-option.liquid.
    var purchaseRoot = root.querySelector('[data-purchase-option]');
    var sellingPlanInput = root.querySelector('[data-selling-plan]');
    var clubPanel = root.querySelector('[data-purchase-club]');
    var clubFooter = root.querySelector('[data-purchase-footer]');
    var clubRadio = purchaseRoot ? purchaseRoot.querySelector('input[name="kaufoption"][value="club"]') : null;
    var priceOldEl = root.querySelector('[data-price-old]');
    var savingsEl = root.querySelector('[data-price-savings]');
    var purchaseRows = purchaseRoot ? Array.prototype.slice.call(purchaseRoot.querySelectorAll('[data-purchase-row]')) : [];
    var rhythmSelect = purchaseRoot ? purchaseRoot.querySelector('[data-rhythm-select]') : null;
    /* Geschenk-Abo (B47, 15.10.2026): dritte Kaufoption „Verschenken“ – Prepaid, 1 kg je Lieferung, Plan aus dem Laufzeit-Select */
    var giftPanel = root.querySelector('[data-purchase-gift]');
    var giftSelect = giftPanel ? giftPanel.querySelector('[data-gift-plan-select]') : null;
    var giftSizeSelect = giftPanel ? giftPanel.querySelector('[data-gift-size-select]') : null;
    var giftShipNote = giftPanel ? giftPanel.querySelector('[data-gift-ship-note]') : null;
    var giftTotalEl = giftPanel ? giftPanel.querySelector('[data-gift-total]') : null;
    var giftTermsEl = root.querySelector('[data-gift-terms]');
    var clubTermsEl = root.querySelector('[data-purchase-terms]');
    var clubLabel = config.clubButtonLabel || 'Im Kult-Abo bestellen';
    var mode = 'onetime';
    var rhythm = (purchaseRoot && purchaseRoot.getAttribute('data-default-rhythm')) || config.defaultRhythm || '4';

    var qty = 1;
    var addToCartLabel = submitBtn ? submitBtn.textContent.trim() : 'In den Warenkorb';

    function isClub() { return purchaseRoot != null && mode === 'club'; }

    function isGift() { return purchaseRoot != null && giftPanel != null && mode === 'gift'; }

    function submitLabel() { return isGift() ? 'Geschenk-Abo kaufen' : isClub() ? clubLabel : addToCartLabel; }

    function isAbo() { return aboOn && isClub(); }

    function sizeLabelFor(grams) { return Calc ? Calc.fmtGrams(grams) : grams + ' g'; }

    /* Variante gleicher Zubereitung (alle Nicht-Größen-Optionen wie `base`) mit der Größe `grams` */
    function variantForGrams(base, grams) {
      if (!base || sizeOptionIndex < 0) return null;
      for (var i = 0; i < variants.length; i++) {
        var opts = variants[i].options || [];
        if (gramsFromLabel(opts[sizeOptionIndex]) !== grams) continue;
        var same = true;
        for (var j = 0; j < opts.length; j++) {
          if (j !== sizeOptionIndex && opts[j] !== base.options[j]) { same = false; break; }
        }
        if (same) return variants[i];
      }
      return null;
    }

    function aboOpts(base, grams, pct) {
      return {
        grams: grams,
        pct: typeof pct === 'number' ? pct : (config.clubPct || 0),
        sizes: [1000, 500, 250].filter(function (g) { return !!variantForGrams(base, g); }),
        variantFor: function (g) { return variantForGrams(base, g); },
        shipping: config.shipping || {}
      };
    }

    /* Geschenk-Abo (15.10.2026): Beutel des gewählten Gebindes (750 g = 500 g + 250 g, größter zuerst) mit dem
       Mahlgrad der aktuellen Auswahl; null, wenn ein Beutel fehlt oder nicht lieferbar ist. */
    var GIFT_BAGS = { 500: [500], 750: [500, 250], 1000: [1000] };
    function giftGrams() { return giftSizeSelect ? (parseInt(giftSizeSelect.value, 10) || 750) : 1000; }
    function giftBags() {
      var base = findMatchingVariant();
      if (!base) return null;
      var bags = [];
      var ok = (GIFT_BAGS[giftGrams()] || [1000]).every(function (g) {
        var v = variantForGrams(base, g);
        if (!v || !v.available) return false;
        bags.push({ id: v.id, price: v.price, grams: g });
        return true;
      });
      return ok ? bags : null;
    }
    /* Versand je Lieferung: 1 kg frei; sonst frei ab der Status-Grenze (Erstbesteller = Braun) auf den Lieferwert
       nach Club-Rabatt (Rabatt je Beutel abgerundet, wie die Kasse rechnet). config.giftVersand aus kult-pdp-config. */
    function giftVersandInfo(bags) {
      var gv = config.giftVersand || { grenze: 0, satz: 0, freiGramm: 1000, variante: 0 };
      var pct = config.clubPct || 0;
      var wert = bags.reduce(function (sum, b) { return sum + (b.price - Math.floor(b.price * pct / 100)); }, 0);
      var frei = (gv.freiGramm > 0 && giftGrams() >= gv.freiGramm) || wert >= (gv.grenze || 0);
      return { frei: frei, satz: gv.satz || 0, moeglich: !!gv.variante, variante: gv.variante };
    }

    /* Angebot für Menge + Rabatt (Mengenrechner nutzt es mit dem Satz der simulierten Stufe) */
    function quoteFor(grams, pct) {
      if (!aboOn) return null;
      return Calc.quote(aboOpts(findMatchingVariant(), grams, pct));
    }

    function setAboGrams(g) {
      aboGrams = Math.min(aboMax, Math.max(aboMin, Math.round(g / aboStep) * aboStep));
      updateAll();
      if (document.activeElement && document.activeElement.disabled && aboValueEl) aboValueEl.focus();
    }

    /* Regler-Anzeige: Wert, Beutel, Versand (unter der Grenze: fehlende Menge + Mehrpreis), Preis je kg */
    function renderAbo(base, q) {
      var label = Calc.fmtGrams(q.grams);
      var bags = Calc.bagsLabel(q.parts);
      if (aboValueEl) {
        aboValueEl.textContent = label;
        aboValueEl.setAttribute('aria-valuenow', String(q.grams));
        aboValueEl.setAttribute('aria-valuetext', label + (bags ? ', ' + bags : ''));
      }
      aboBox.querySelectorAll('[data-abo-step]').forEach(function (b) {
        b.disabled = parseInt(b.getAttribute('data-abo-step'), 10) < 0 ? q.grams <= aboMin : q.grams >= aboMax;
      });
      if (aboBagsEl) aboBagsEl.textContent = q.available ? 'Beutel: ' + bags : 'In dieser Zubereitung gerade nicht in allen Beutelgrößen lieferbar.';
      var shipText = '';
      var perKgText = '';
      if (q.available) {
        if (q.free) {
          shipText = 'Versandfrei';
        } else {
          /* 13.10.2026 (Philip): kein Schubser „Noch 250 g … nur X € mehr“ mehr – die Lieferung knapp über der Grenze bringt am wenigsten je kg. Nur der Sachstand. */
          var nf = Calc.nextFree(aboOpts(base, q.grams), aboMax, aboStep);
          shipText = 'Versand je Lieferung ' + formatPrice(q.shipCents) + (nf ? ' · ab ' + Calc.fmtGrams(nf.grams) + ' versandfrei.' : '.');
          /* Kleine Mengen: kurzer Rhythmus statt größerer Lieferung (Philip 13.10.2026) */
          if (q.grams <= 750) shipText += ' Tipp: Mit einem kurzen Rhythmus (alle 2 oder 3 Wochen) ist dein Kaffee immer frisch geröstet.';
        }
        perKgText = formatPrice(q.perKgCents) + ' je kg' + (q.free ? ', versandfrei' : ' inkl. ' + formatPrice(q.shipCents) + ' Versand');
        var cheapest = Calc.cheapestPerKg(aboOpts(base, q.grams), aboMin, aboMax, aboStep);
        if (cheapest && cheapest === q.grams) perKgText += ' · ' + label + ' ist der günstigste Punkt pro kg.';
      }
      if (aboShipEl) {
        aboShipEl.textContent = shipText;
        aboShipEl.classList.toggle('is-free', !!(q.available && q.free));
      }
      if (aboPerKgEl) aboPerKgEl.textContent = perKgText;
    }

    /* Einzelkauf: Mengenvorteil gegenüber 250-g-Beuteln (abgerundet, nur > 0) */
    function updateSizeSaving(variant) {
      if (!sizeSavingEl) return;
      var text = '';
      var g = variant && sizeOptionIndex > -1 ? gramsFromLabel(variant.options[sizeOptionIndex]) : null;
      var small = g ? variantForGrams(variant, 250) : null;
      if (!isClub() && g > 250 && g % 250 === 0 && small && small.price > 0) {
        var n = g / 250;
        var pct = Math.floor((1 - variant.price / (n * small.price)) * 100);
        if (pct > 0) text = sizeLabelFor(g) + ': du sparst ' + pct + ' % gegenüber ' + n + ' × ' + sizeLabelFor(250);
      }
      sizeSavingEl.textContent = text;
      sizeSavingEl.hidden = !text;
    }

    /* Grundpreis im Club-Modus aus dem bereits gerundeten Club-Preis ableiten (identisch zur Warenkorb-Rechnung) */
    function clubUnitCentsFor(variant) {
      if (!variant.unitPrice || !variant.price) return 0;
      return Math.round(clubPriceCents(variant.price) * variant.unitPrice / variant.price);
    }
    /* Rabatt auf den Cent abgerundet wie Shopify-Warenkorb und Kasse (UX-Review S3, assets/kult-abo-calc.js) */
    function clubPriceCents(cents) {
      var pct = config.clubPct || 0;
      return (cents || 0) - Math.floor((cents || 0) * pct / 100);
    }

    function setRhythm(r) {
      if (!purchaseRoot) return;
      var plans = config.plans || {};
      var planId = plans[r];
      if (!planId) return;
      rhythm = r;
      if (rhythmSelect && rhythmSelect.value !== r) rhythmSelect.value = r;
      if (sellingPlanInput) sellingPlanInput.value = planId;
    }

    /* Stückzahl Einzelkauf: ganze Zahl 1–99 (Stepper, ?quantity=, Wechsel aus dem Abo) */
    function setQty(n) {
      qty = Math.min(QTY_MAX, Math.max(1, parseInt(n, 10) || 1));
      if (qtyValueEl) qtyValueEl.textContent = qty;
      if (quantityInput) quantityInput.value = qty;
    }

    /* Größen-Pill zur Abo-Menge: gleiche Größe (500 g, 1 kg), sonst die kleinste Größe, die die Menge abdeckt,
       sonst die größte (z. B. 750 g → 1 kg, 2 kg → 1 kg) */
    function selectSizeForGrams(grams) {
      if (!sizeGroupEl || !grams) return;
      var pills = Array.prototype.slice.call(sizeGroupEl.querySelectorAll('.kult-pdp-variant__pill'));
      var target = null;
      var targetG = 0;
      var largest = null;
      var largestG = 0;
      pills.forEach(function (p) {
        var g = gramsFromLabel(p.getAttribute('data-option-value'));
        if (!g) return;
        if (g > largestG) { largest = p; largestG = g; }
        if (g >= grams && (!target || g < targetG)) { target = p; targetG = g; }
      });
      target = target || largest;
      if (!target) return;
      pills.forEach(function (p) {
        var on = p === target;
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function setMode(next) {
      if (!purchaseRoot) return;
      var wasClub = isClub();
      mode = next;
      var club = isClub();
      var gift = isGift();
      purchaseRows.forEach(function (row) {
        var active = row.getAttribute('data-purchase-row') === next;
        row.classList.toggle('is-active', active);
        var radio = row.querySelector('.kult-purchase__radio');
        if (radio) radio.checked = active;
      });
      if (clubPanel) clubPanel.hidden = !club;
      if (giftPanel) giftPanel.hidden = !gift;
      if (clubFooter) clubFooter.hidden = !(club || gift);
      /* Pflichtangaben je Kaufart: Club-Terms (Abbuchung je Lieferung) vs. Geschenk-Terms (Einmalzahlung, Verfall-Hinweis) */
      if (clubTermsEl) clubTermsEl.hidden = gift;
      if (giftTermsEl) giftTermsEl.hidden = !gift;
      var clubLegalEl = root.querySelector('[data-club-legal]');
      var giftLegalEl = root.querySelector('[data-gift-legal]');
      if (clubLegalEl) clubLegalEl.hidden = gift;
      if (giftLegalEl) giftLegalEl.hidden = !gift;
      /* Preisnotiz: Geschenk ist versandkostenfrei (1 kg je Lieferung); Club-Werbung und Größen-Ersparnis passen nicht zum Geschenk */
      var noteStd = root.querySelector('[data-price-note-standard]');
      var noteGift = root.querySelector('[data-price-note-gift]');
      if (noteStd) noteStd.hidden = gift;
      if (noteGift) noteGift.hidden = !gift;
      var promoEl = root.querySelector('.kult-club-promo');
      if (promoEl) promoEl.hidden = gift;
      if (sizeSavingEl) sizeSavingEl.hidden = gift;
      /* Texte je Kaufart (Club-Werbung ohne doppelten Rabatt im Abo, Versand-Vertrauenszeile; UX-Review S2/S5) */
      root.querySelectorAll('[data-mode-show]').forEach(function (el) {
        el.hidden = el.getAttribute('data-mode-show') !== (club ? 'club' : gift ? 'gift' : 'onetime');
      });
      var giftRadio = purchaseRoot.querySelector('input[name="kaufoption"][value="gift"]');
      if (sellingPlanInput) sellingPlanInput.disabled = !club;
      if (club) setRhythm(rhythm);
      /* Geschenk-Abo: Gebinde 500 g/750 g/1 kg aus dem eigenen Select (Philip 15.10.2026), Mahlgrad bleibt wählbar */
      if (gift) {
        setQty(1);
      }
      if (aboOn) {
        if (club) {
          /* Startwert aus der gewählten Größe (250 g → 500 g) */
          var cur = findMatchingVariant();
          var g = cur ? gramsFromLabel(cur.options[sizeOptionIndex]) : null;
          aboGrams = Math.min(aboMax, Math.max(aboMin, g || aboMin));
        } else if (wasClub && !gift) {
          /* Abo → Einmalig (990-Bug 11.10.2026): eine Packung in der Größe des Reglers, Stückzahl 1 */
          selectSizeForGrams(aboGrams);
          setQty(1);
        }
        aboBox.hidden = !club;
      }
      if (sizeGroupEl && (aboOn || giftPanel)) sizeGroupEl.hidden = (aboOn && club) || gift;
      if (qtyStepperEl && (aboOn || giftPanel)) qtyStepperEl.hidden = (aboOn && club) || gift;
      if (shippingBar && (aboOn || giftPanel)) shippingBar.hidden = club || gift;
      updateAll();
    }

    function selectedOptionValue(groupIndex) {
      if (groupIndex === null || groupIndex === undefined || groupIndex < 0) return null;
      var pill = root.querySelector('[data-option-index="' + groupIndex + '"].is-active');
      return pill ? pill.getAttribute('data-option-value') : null;
    }

    // Optionen, die per Pill gewählt werden: Kaffee = Größe + Zubereitung,
    // Zubehör = alle Optionen des Produkts (config.optionIndices).
    var optionIndices = Array.isArray(config.optionIndices)
      ? config.optionIndices
      : [sizeOptionIndex, grindOptionIndex].filter(function (i) { return typeof i === 'number' && i > -1; });

    function findMatchingVariant() {
      var selected = optionIndices.map(function (i) { return { index: i, value: selectedOptionValue(i) }; });
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var opts = v.options || [];
        var matches = selected.every(function (s) { return opts[s.index] === s.value; });
        if (matches) return v;
      }
      /* Ohne exakte Variante: gleiche Zubereitung in irgendeiner Größe (Abo-Regler rechnet die Größen selbst) */
      var noSize = selected.filter(function (s) { return s.index !== sizeOptionIndex; });
      for (var k = 0; noSize.length && k < variants.length; k++) {
        var o = variants[k].options || [];
        if (noSize.every(function (s) { return o[s.index] === s.value; })) return variants[k];
      }
      return variants[0] || null;
    }

    /* Versandbalken: rechnet NUR mit dem echten Warenkorbwert (nicht mit der noch nicht abgelegten Position).
       Schwelle (Zubehör/Probierset): Club-Modus oder Abo-Zeile im Warenkorb → Club-Freigrenze, sonst Einmalkauf-Grenze.
       Nach jeder Warenkorb-Änderung (kult:cart:add / kult:cart:updated) werden Wert und Abo-Kennzeichen übernommen. */
    /* Kaffee-PDP (Kult Club nach kg): Lücke = Versandfrei-Grenze des Zustands minus Einmalkauf-Warenwert im
       Warenkorb (ohne Beutelgrößen-Zusatz, Entscheidung Philip 10.10.2026). Im Abo ausgeblendet.
       Abo hat Vorrang (Entscheidung Philip 09.10.2026): Liegt ein Kult-Abo im Warenkorb (data-cart-abo-g ≥ 0, nur mit
       Gramm-Grenze), gilt für die ganze Bestellung die Abo-Regel nach Gramm, kein Einzelkauf-Hinweis in €. */
    function updateOnetimeShipping() {
      var aboFrei = (config.shipping && config.shipping.aboFreiGramm) || 0;
      var aboG = parseInt(shippingBar.getAttribute('data-cart-abo-g'), 10);
      if (aboFrei > 0 && aboG >= 0) {
        var aboRest = Math.max(0, aboFrei - aboG);
        var fmtG = Calc ? Calc.fmtGrams : function (g) { return g + ' g'; };
        if (shippingIconDefault) shippingIconDefault.hidden = aboRest === 0;
        if (shippingIconDone) shippingIconDone.hidden = aboRest > 0;
        /* 13.10.2026 (Philip): kein „Noch X g bis versandfrei“ mehr, nur die Regel */
        if (shippingText) shippingText.textContent = aboRest > 0 ? 'Kult-Abo: ab ' + fmtG(aboFrei) + ' je Lieferung versandfrei' : 'Versandfrei mit deinem Kult-Abo';
        return;
      }
      var limit = config.onetimeFreeCents;
      var cartCents = parseInt(shippingBar.getAttribute('data-cart-onetime'), 10) || 0;
      var gap = limit - cartCents;
      var done = limit === 0 || gap <= 0;
      var gold = config.clubState === 'gold';
      var text = gold ? 'Versandfrei im Kult Status Gold' : 'Versandfrei';
      if (!done) {
        var tail = '.';
        text = cartCents > 0 ? 'Noch ' + formatPrice(gap) + ' bis versandfrei' + (gold ? ' (ab ' + formatLimit(limit) + ' im Kult Status Gold)' : '') + tail : 'Versandfrei ab ' + formatLimit(limit) + (gold ? ' im Kult Status Gold' : '') + tail;
      }
      if (shippingIconDefault) shippingIconDefault.hidden = done;
      if (shippingIconDone) shippingIconDone.hidden = !done;
      if (shippingText) shippingText.textContent = text;
    }

    function updateShippingBar() {
      if (!shippingBar) return;
      if (typeof config.onetimeFreeCents === 'number') { updateOnetimeShipping(); return; }
      var club = isClub();
      var cartTotalCents = parseInt(shippingBar.getAttribute('data-cart-total'), 10) || 0;
      var cartHasClub = shippingBar.getAttribute('data-cart-club') === 'true';
      var clubThreshold = (config.thresholdClub || 0);
      var thresholdEur = ((club || cartHasClub) && clubThreshold) ? clubThreshold : threshold;
      var thresholdCents = thresholdEur * 100;
      var remainingCents = thresholdCents - cartTotalCents;
      var clubLabel = ' bis zum Gratisversand im Kult-Abo (ab ' + formatLimit(clubThreshold * 100) + ')';

      if (cartTotalCents <= 0) {
        if (shippingIconDefault) shippingIconDefault.hidden = false;
        if (shippingIconDone) shippingIconDone.hidden = true;
        if (shippingText) {
          shippingText.textContent = thresholdCents === 0 ? 'Immer versandfrei – Kult Status Gold' : club && clubThreshold
            ? 'Im Kult-Abo versandkostenfrei ab ' + formatLimit(clubThreshold * 100)
            : 'Versandkostenfrei ab ' + formatLimit(thresholdCents) + (clubThreshold && clubThreshold !== threshold ? ' · im Kult-Abo ab ' + formatLimit(clubThreshold * 100) : '');
        }
      } else if (remainingCents <= 0) {
        if (shippingIconDefault) shippingIconDefault.hidden = true;
        if (shippingIconDone) shippingIconDone.hidden = false;
        if (shippingText) shippingText.textContent = 'Versandkostenfrei – dein Versand ist gratis';
      } else {
        if (shippingIconDefault) shippingIconDefault.hidden = false;
        if (shippingIconDone) shippingIconDone.hidden = true;
        if (shippingText) {
          shippingText.textContent = 'Noch ' + formatPrice(remainingCents) + ((club || cartHasClub) && clubThreshold ? clubLabel : ' bis zum kostenlosen Versand');
        }
      }
    }

    function syncCartToShippingBar(cart) {
      if (!shippingBar || !cart) return;
      shippingBar.setAttribute('data-cart-total', String(cart.total_price || 0));
      /* Gold (Entscheidung Philip 09.10.2026): Euro-Grenze 25 € zählt auch Abo-Zeilen mit */
      var goldAll = config.clubState === 'gold';
      var onetime = (cart.items || []).reduce(function (sum, i) {
        /* Option B (15.10.2026): Gutscheine/Seminare zählen zur €-Grenze mit (wie der Kassen-Rabatt) */
        return sum + (goldAll || !i.selling_plan_allocation ? (i.final_line_price || 0) : 0);
      }, 0);
      shippingBar.setAttribute('data-cart-onetime', String(onetime));
      var hasClub = (cart.items || []).some(function (i) { return !!i.selling_plan_allocation; });
      shippingBar.setAttribute('data-cart-club', hasClub ? 'true' : 'false');
      /* Kleinste Abo-Lieferung in Gramm (Zeilen je Plan, Gramm aus SKU KR-XXX-250|500|1000-YY), -1 = kein Abo */
      var plans = {};
      (cart.items || []).forEach(function (i) {
        var sp = i.selling_plan_allocation && i.selling_plan_allocation.selling_plan;
        if (!sp) return;
        var parts = String(i.sku || '').split('-');
        plans[sp.id] = (plans[sp.id] || 0) + (parts.length === 4 && parts[0] === 'KR' ? (parseInt(parts[2], 10) || 0) * (i.quantity || 0) : 0);
      });
      var planIds = Object.keys(plans);
      shippingBar.setAttribute('data-cart-abo-g', String(planIds.length ? Math.min.apply(null, planIds.map(function (k) { return plans[k]; })) : -1));
      updateShippingBar();
    }
    document.addEventListener('kult:cart:add', function (e) { syncCartToShippingBar(e.detail && e.detail.cart); });
    document.addEventListener('kult:cart:updated', function (e) { syncCartToShippingBar(e.detail && e.detail.cart); });

    function updateAll() {
      var variant = findMatchingVariant();

      root.querySelectorAll('.kult-pdp-variant__pill.is-active').forEach(function (p) {
        p.classList.toggle('is-disabled', !(variant && variant.available));
      });

      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      /* Kaufleiste: gewählte Zubereitung (Anzeige-Label wie in den Pills, Philip 24.10.2026) */
      if (buybarGrind && grindOptionIndex > -1) {
        var gVal = selectedOptionValue(grindOptionIndex) || (variant.options || [])[grindOptionIndex] || '';
        if (window.KultGrind) gVal = window.KultGrind.visible(gVal);
        buybarGrind.textContent = grindLabel(gVal);
        buybarGrind.hidden = !gVal;
      }

      var lineTotalCents = variant.price * qty;
      /* Geschenk-Abo (Befund J): der große Preis ist die EINMALSUMME aller Lieferungen (Beutel des Gebindes × N, inkl. Versand-Position) */
      var giftBagsNow = isGift() ? giftBags() : null;
      if (isGift() && giftSelect) {
        var gN0 = parseInt(giftSelect.value, 10) || 3;
        if (giftBagsNow) {
          var gJe0 = giftBagsNow.reduce(function (sum, b) { return sum + b.price; }, 0);
          var gVi0 = giftVersandInfo(giftBagsNow);
          lineTotalCents = gJe0 * gN0 + (gVi0.frei || !gVi0.moeglich ? 0 : gVi0.satz * gN0);
        } else {
          lineTotalCents = variant.price * gN0;
        }
      }
      if (priceEl) priceEl.textContent = formatPrice(lineTotalCents);
      if (buybarPrice) buybarPrice.textContent = formatPrice(lineTotalCents);

      updateSizeSaving(variant);
      var aboQ = isAbo() ? Calc.quote(aboOpts(variant, aboGrams)) : null;
      if (aboQ) renderAbo(variant, aboQ);

      /* Geschenk-Abo: Gesamtpreis = Beutel des Gebindes × Lieferzahl; der Club-Preis (mind. Braun) geht an der Kasse ab */
      if (giftTotalEl && isGift() && giftSelect) {
        var giftN = parseInt(giftSelect.value, 10) || 3;
        var giftPct = config.clubPct || 0;
        if (giftBagsNow) {
          var giftJe = giftBagsNow.reduce(function (sum, b) { return sum + b.price; }, 0);
          var giftTotal = giftJe * giftN;
          var giftVi = giftVersandInfo(giftBagsNow);
          var giftShip = giftVi.frei || !giftVi.moeglich ? 0 : giftVi.satz * giftN;
          var giftRabatt = Math.floor(giftTotal * giftPct / 100);
          var giftSizeLabel = giftGrams() >= 1000 ? '1 kg' : giftGrams() + ' g';
          giftTotalEl.textContent = 'Einmalig ' + formatPrice(giftTotal + giftShip) + ' für ' + giftN + ' Lieferungen à ' + giftSizeLabel +
            (giftPct > 0 ? ' – im Warenkorb gehen ' + giftPct + ' % Club-Preis ab (du sparst ca. ' + formatPrice(giftRabatt) + ').' : '.');
          if (giftShipNote) {
            if (giftShip > 0) {
              giftShipNote.textContent = 'Darin enthalten: Versand ' + formatPrice(giftShip) + ' (' + giftN + ' Lieferungen à ' + formatPrice(giftVi.satz) + ') – entfällt ab 1 kg je Lieferung.';
              giftShipNote.hidden = false;
            } else if (giftVi.frei) {
              giftShipNote.textContent = giftGrams() >= 1000 ? 'Versandkostenfrei (ab 1 kg je Lieferung).' : 'Versandkostenfrei dank deiner Kult-Status-Grenze.';
              giftShipNote.hidden = false;
            } else {
              giftShipNote.hidden = true;
            }
          }
        } else {
          giftTotalEl.textContent = 'Diese Menge ist in diesem Mahlgrad gerade nicht lieferbar – bitte wähle eine andere Menge.';
          if (giftShipNote) giftShipNote.hidden = true;
        }
        if (submitBtn) submitBtn.disabled = isGift() && !giftBagsNow;
      }

      if (purchaseRoot) {
        var club = isClub();
        var clubUnitCents = clubPriceCents(variant.price);
        /* Club-Preis (Status-Rabatt) gilt nur im Abo (Philip 28.09.2026); der Einmalkauf bleibt beim Online-Preis */
        var memberState = (config.clubState === 'braun' || config.clubState === 'silber' || config.clubState === 'gold') ? config.clubState : '';
        var statusLabel = memberState === 'gold' ? 'Gold' : (memberState === 'silber' ? 'Silber' : 'Braun');
        if (club) {
          lineTotalCents = aboQ ? aboQ.aboCents : clubUnitCents * qty;
          if (priceEl) priceEl.textContent = formatPrice(lineTotalCents);
          if (buybarPrice) buybarPrice.textContent = formatPrice(lineTotalCents);
        }
        if (priceEl) { if (memberState && club) priceEl.setAttribute('data-status', memberState); else priceEl.removeAttribute('data-status'); }
        if (savingsEl) { if (memberState) savingsEl.setAttribute('data-status', memberState); else savingsEl.removeAttribute('data-status'); }
        if (priceOldEl) {
          priceOldEl.hidden = !club;
          if (club) priceOldEl.textContent = formatPrice(aboQ ? aboQ.listCents : variant.price * qty);
        }
        if (savingsEl) {
          if (club) {
            /* Ersparnis auf die gewählte Menge (Online-Preis minus Club-Preis) */
            var savingsCents = aboQ ? aboQ.listCents - aboQ.aboCents : (variant.price - clubUnitCents) * qty;
            savingsEl.hidden = savingsCents <= 0;
            if (savingsCents > 0) savingsEl.textContent = 'Im Kult-Abo sparst du ' + formatPrice(savingsCents) + (memberState && memberState !== 'braun' ? ' (Kult Status ' + statusLabel + ' −' + (config.clubPct || 0) + ' %)' : '');
          } else {
            /* Einmalkauf: Enticement mit dem Club-Preis der eigenen Stufe (Mitglied) bzw. Braun (Gast/Kunde) auf die gewählte Menge */
            var entPct = memberState ? (config.clubPct || 0) : (config.pctBraun || 0);
            /* gleiche Rundung wie Warenkorb und Kasse (Rabatt je Beutel auf den Cent abgerundet, × Menge) */
            var onetimeSavingsCents = Math.floor(variant.price * entPct / 100) * qty;
            /* Abo gibt es erst ab der kleinsten Abo-Menge (250 g nicht im Abo): darunter kein Hinweis */
            var vGrams = aboOn ? gramsFromLabel(variant.options[sizeOptionIndex]) : null;
            if (aboOn && vGrams && vGrams < aboMin) onetimeSavingsCents = 0;
            savingsEl.hidden = !config.clubEnabled || onetimeSavingsCents <= 0;
            if (config.clubEnabled && onetimeSavingsCents > 0) savingsEl.textContent = 'Im Kult-Abo sparst du ' + formatPrice(onetimeSavingsCents) + (memberState && memberState !== 'braun' ? ' (Kult Status ' + statusLabel + ' −' + entPct + ' %)' : '');
          }
        }
      }

      var grindValue = grindOptionIndex > -1 ? variant.options[grindOptionIndex] : '';
      var wholeBean = isWholeBeanValue(grindValue);

      if (grindHintEl) {
        grindHintEl.textContent = wholeBean
          ? 'Du erhältst ganze Bohnen – frisch gemahlen schmeckt es am besten.'
          : 'Wir mahlen frisch für deinen ' + grindLabel(grindValue) + '.';
      }
      if (legalGrindEl) {
        legalGrindEl.textContent = wholeBean ? 'ganze Bohne' : 'gemahlen für ' + grindLabel(grindValue);
      }
      if (legalSizeEl && sizeOptionIndex > -1) {
        legalSizeEl.textContent = aboQ ? Calc.fmtGrams(aboQ.grams) + ' je Lieferung (' + Calc.bagsLabel(aboQ.parts) + ')' : variant.options[sizeOptionIndex];
      }

      if (unitPriceEl) {
        if (variant.unitPrice) {
          unitPriceEl.hidden = false;
          /* Im Club-Modus Grundpreis aus dem rabattierten Preis (PAngV, konsistent zur Preiszeile).
             Trenner " · " vor dem Folgetext kommt rein aus CSS (::after auf
             .kult-buy-widget__legal-unit), damit der Text hier unverändert
             bleibt — dieselbe Funktion bedient auch die Grundpreis-Anzeige in
             kult-pdp-sampler-buybox.liquid/kult-pdp-accessory-buybox.liquid
             ohne Satzkontext. */
          var shownUnit = aboQ ? aboQ.unitCents : (isClub() ? clubUnitCentsFor(variant) : variant.unitPrice);
          unitPriceEl.textContent = formatPrice(shownUnit) + '/' + (aboQ ? 'kg' : (variant.unitRef || 'kg'));
        } else {
          unitPriceEl.hidden = true;
        }
      }

      if (submitBtn) {
        if (aboQ ? !aboQ.available : !variant.available) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Nicht verfügbar';
        } else {
          submitBtn.disabled = false;
          submitBtn.textContent = submitLabel();
        }
        if (buybarBtn) buybarBtn.textContent = submitBtn.textContent;
      }

      updateShippingBar();
      if (root._kultQtyFinderUpdate && root.querySelector('[data-qty-finder].is-open')) root._kultQtyFinderUpdate();

      document.dispatchEvent(new CustomEvent('kult:pdp:grind', {
        detail: { method: methodKeyFromGrindValue(grindValue) }
      }));
    }

    root.querySelectorAll('.kult-pdp-variant__pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var group = pill.closest('[data-variant-group]');
        if (!group) return;
        group.querySelectorAll('.kult-pdp-variant__pill').forEach(function (p) { p.classList.remove('is-active'); p.setAttribute('aria-pressed', 'false'); });
        pill.classList.add('is-active');
        pill.setAttribute('aria-pressed', 'true');
        updateAll();
      });
    });

    /* Nur die Stepper-Buttons (button[data-step]); der Abo-Regler-Container trug früher data-step="250" und zählte
       jeden Tipp darin auf die Einzelkauf-Stückzahl (990-Bug 11.10.2026) */
    root.querySelectorAll('button[data-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setQty(qty + (parseInt(btn.getAttribute('data-step'), 10) || 0));
        updateAll();
      });
    });

    if (aboOn) {
      aboBox.querySelectorAll('[data-abo-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setAboGrams(aboGrams + parseInt(btn.getAttribute('data-abo-step'), 10) * aboStep);
        });
      });
      if (aboValueEl) {
        aboValueEl.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowUp' || e.key === 'ArrowRight') next = aboGrams + aboStep;
          else if (e.key === 'ArrowDown' || e.key === 'ArrowLeft') next = aboGrams - aboStep;
          else if (e.key === 'PageUp') next = aboGrams + 4 * aboStep;
          else if (e.key === 'PageDown') next = aboGrams - 4 * aboStep;
          else if (e.key === 'Home') next = aboMin;
          else if (e.key === 'End') next = aboMax;
          if (next === null) return;
          e.preventDefault();
          setAboGrams(next);
        });
      }
    }

    if (purchaseRoot) {
      purchaseRoot.querySelectorAll('input[name="kaufoption"]').forEach(function (input) {
        input.addEventListener('change', function () { setMode(input.value); });
        input.addEventListener('focus', function () {
          var row = input.closest('.kult-purchase__row');
          if (row) row.classList.add('is-focus');
        });
        input.addEventListener('blur', function () {
          var row = input.closest('.kult-purchase__row');
          if (row) row.classList.remove('is-focus');
        });
      });

      if (rhythmSelect) {
        rhythmSelect.addEventListener('change', function () { setRhythm(rhythmSelect.value); });
      }
      if (giftSelect) {
        giftSelect.addEventListener('change', function () { updateAll(); });
      }
      if (giftSizeSelect) {
        giftSizeSelect.addEventListener('change', function () { updateAll(); });
      }
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!submitBtn || submitBtn.disabled) return;

        var request;
        if (isAbo()) {
          /* Abo-Menge: je Beutelgröße eine Zeile, alle mit demselben Plan, gebündelt über _kultabo_set */
          var aq = Calc.quote(aboOpts(findMatchingVariant(), aboGrams));
          var aboPlanId = (config.plans || {})[rhythm];
          if (!aq.available || !aboPlanId) return;
          var setId = Calc.setId();
          var items = aq.lines.map(function (l, i) {
            var props = { _kultabo_set: setId };
            if (i === 0) props['Abo-Menge'] = Calc.fmtGrams(aq.grams);
            return { id: l.id, quantity: l.count, selling_plan: aboPlanId, properties: props };
          });
          request = { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) };
        } else {
          var formData = new FormData(form);
          /* Seal-App-Embed entfernt das versteckte selling_plan-Feld aus dem Formular (26.09.2026):
             Plan-ID darum immer aus dem gewählten Rhythmus setzen, Einmalkauf ohne selling_plan. */
          if (isGift()) {
            /* Geschenk-Abo: Prepaid-Plan aus dem Laufzeit-Select; Gebinde-Beutel je Zeile + ggf. Versand-Position
               (_kultgift_set gruppiert sie, snippets/kult-cart-gift-set.liquid rendert sie als EINE Zeile) */
            var giftOpt = giftSelect && giftSelect.options[giftSelect.selectedIndex];
            var giftPlanId = giftOpt && giftOpt.getAttribute('data-plan-id');
            var gBags = giftBags();
            if (!giftPlanId || !gBags) return;
            var gN = parseInt(giftSelect.value, 10) || 3;
            var gSet = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
            var gSize = giftGrams() >= 1000 ? '1 kg' : giftGrams() + ' g';
            var gItems = gBags.map(function (b) {
              /* Marker auf JEDER Beutel-Zeile: versand.server.ts teilt die Prepaid-Menge je Zeile durch die Lieferzahl */
              return { id: b.id, quantity: 1, selling_plan: Number(giftPlanId), properties: { _kultgift_set: gSet, 'Geschenk-Abo': gN + ' Lieferungen à ' + gSize } };
            });
            var gVi = giftVersandInfo(gBags);
            if (!gVi.frei && gVi.moeglich) gItems.push({ id: gVi.variante, quantity: gN, properties: { _kultgift_set: gSet, _kultgift_versand: '1' } });
            request = { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: gItems }) };
          } else if (isClub()) {
            var planId = (config.plans || {})[rhythm];
            if (planId) formData.set('selling_plan', planId);
          } else {
            formData.delete('selling_plan');
          }
          if (!request) request = { method: 'POST', headers: { Accept: 'application/json' }, body: formData };
        }
        submitBtn.disabled = true;
        submitBtn.textContent = 'Wird hinzugefügt…';
        if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

        fetch(config.addUrl + '.js', request)
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (data) {
                throw new Error((data && data.description) || 'Der Artikel konnte nicht hinzugefügt werden.');
              });
            }
            return res.json();
          })
          .then(function (added) {
            submitBtn.textContent = 'Im Warenkorb';
            var title = (added && (added.product_title || (added.items && added.items[0] && added.items[0].product_title))) || '';
            return fetch('/cart.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                document.dispatchEvent(new CustomEvent('kult:cart:add', { detail: { cart: cart, title: title } }));
                window.setTimeout(function () {
                  submitBtn.disabled = false;
                  submitBtn.textContent = submitLabel();
                  if (buybarBtn) buybarBtn.textContent = submitBtn.textContent;
                }, 1200);
              });
          })
          .catch(function (err) {
            submitBtn.disabled = false;
            submitBtn.textContent = submitLabel();
            if (buybarBtn) buybarBtn.textContent = submitBtn.textContent;
            if (errorEl) {
              errorEl.hidden = false;
              errorEl.textContent = err.message || 'Es ist ein Fehler aufgetreten.';
            }
          });
      });
    }

    initQtyFinder(root, config, findMatchingVariant, sizeOptionIndex, aboOn ? quoteFor : null);
    initSamplerPicks(root);
    setQty(qty);
    initPurchaseOptionFromUrl();
    updateAll();

    // ?selling_plan=<id> oder ?club=1 wählt die Club-Kaufoption vor, ?quantity=n die Menge.
    // Eigene Funktion (statt Top-Level-Code) für saubere Fehlerisolierung bei defektem purchaseRoot.
    function initPurchaseOptionFromUrl() {
      var params = new URLSearchParams(window.location.search);
      var qParam = parseInt(params.get('quantity'), 10);
      if (qParam >= 1 && qParam <= QTY_MAX) setQty(qParam);
      if (!purchaseRoot) return;
      var spParam = params.get('selling_plan');
      var clubParam = params.get('club');
      if (spParam) {
        var plans = config.plans || {};
        var matchedRhythm = null;
        Object.keys(plans).forEach(function (key) {
          if (String(plans[key]) === spParam) matchedRhythm = key;
        });
        if (matchedRhythm) {
          rhythm = matchedRhythm;
          setMode('club');
        }
      } else if (clubParam === '1') {
        setMode('club');
      }
    }
  }

  /* Probierset: Dropdowns „Sorte 1–3“ aus ?s1=&s2=&s3= (Handles) vorbelegen. */
  function initSamplerPicks(root) {
    var selects = root.querySelectorAll('[data-sampler-select]');
    if (!selects.length) return;
    var params = new URLSearchParams(window.location.search);
    selects.forEach(function (sel) {
      var handle = params.get('s' + sel.getAttribute('data-sampler-select'));
      if (!handle) return;
      var opt = sel.querySelector('option[data-handle="' + handle.replace(/"/g, '') + '"]');
      if (opt) sel.value = opt.value;
    });
  }

  function initQtyFinder(root, config, getCurrentVariant, sizeOptionIndex, quoteFor) {
    var toggle = root.querySelector('[data-calc-toggle]');
    var popover = root.querySelector('[data-qty-finder]');
    if (!toggle || !popover) return;

    var cupsInput = root.querySelector('[data-qf-cups]');
    var cupsOut = root.querySelector('[data-qf-cups-out]');
    var methodSelect = root.querySelector('[data-qf-method]');
    var resultEl = root.querySelector('[data-qty-result]');
    var clubEl = root.querySelector('[data-qty-club]');

    /* Einmalkauf-Empfehlung, Zerlegung unverändert (volle Kilos, Rest > 750 g = 1 kg, > 500 g = 500 g + 250 g, > 250 g = 500 g,
       sonst 250 g); Anzeige zusammengefasst mit Multiplikator, z. B. „2 × 1 kg“ oder „1 × 1 kg + 1 × 500 g“ (11.10.2026) */
    function packagingRecommendation(totalGrams) {
      var kg = Math.floor(totalGrams / 1000);
      var rem = totalGrams - (kg * 1000);
      var counts = { 1000: kg, 500: 0, 250: 0 };
      if (rem > 750) counts[1000] += 1;
      else if (rem > 500) { counts[500] = 1; counts[250] = 1; }
      else if (rem > 250) counts[500] = 1;
      else if (rem > 0) counts[250] = 1;
      var parts = [1000, 500, 250].filter(function (g) { return counts[g] > 0; })
        .map(function (g) { return counts[g] + ' × ' + kgLabel(g); });
      return parts.length ? parts.join(' + ') : '—';
    }
    /* „250 g“, „1 kg“, „1,75 kg“ */
    function kgLabel(g) {
      if (g < 1000) return Math.round(g) + ' g';
      return (Math.round(g / 10) / 100).toLocaleString('de-DE', { maximumFractionDigits: 2 }) + ' kg';
    }

    /* Kult Club nach kg (09.10.2026): Abo-Menge je 4 Wochen aus dem Bedarf (500–3.000 g, Beutel größter zuerst),
       Preis je Lieferung mit Status-Rabatt und Abo-Versand (assets/kult-abo-calc.js über quoteFor). Für Gast und
       Kunde ohne Kult-Abo: 13 Lieferungen ab Braun (mit der ersten Abo-Bestellung, Regel 09.10.2026), Status aus den Abo-kg
       (Silber/Gold ab settings.kult_club_*_kg), Aufstieg wirkt ab der nächsten Lieferung. Mitglieder: eigener Satz.
       Kompakte Karte (11.10.2026): Menge, Preis je Lieferung, Ersparnis im Jahr (nur > 0), Status-Zeile nur für Mitglieder.
       Gibt das HTML der Karte zurück (leer ohne Kult-Abo). Reine Richtwert-Anzeige, die Kasse rechnet den tatsächlichen Rabatt. */
    function renderClub(gramsPerMonth) {
      var calc = window.KultAboCalc;
      if (!config || !config.clubEnabled || !calc || typeof quoteFor !== 'function') return '';
      var min = config.aboMinG || 500;
      var max = config.aboMaxG || 3000;
      var step = config.aboStepG || 250;
      var grams = Math.min(max, Math.max(min, Math.round(gramsPerMonth * 28 / 30 / step) * step));
      var pcts = { braun: config.pctBraun || 0, silber: config.pctSilber || 0, gold: config.pctGold || 0 };
      var silberG = Math.round((parseFloat(config.silberKg) || 6) * 1000);
      var goldG = Math.round((parseFloat(config.goldKg) || 12) * 1000);
      var member = ['braun', 'silber', 'gold'].indexOf(config.clubState) > -1;
      var startStatus = member && pcts[config.stufe] !== undefined ? config.stufe : 'braun';
      var first = quoteFor(grams, pcts[startStatus]);
      if (!first || !first.available) return '';

      var onetimeFree = typeof config.onetimeFreeCents === 'number' ? config.onetimeFreeCents : 0;
      var onetimeShip = onetimeFree > 0 && first.listCents < onetimeFree ? (config.versandCents || 0) : 0;
      var statusLabels = { braun: 'Braun', silber: 'Silber', gold: 'Gold' };
      var totalAll = 0;
      for (var n = 1; n <= 13; n++) {
        var status = startStatus;
        if (!member) {
          var before = (n - 1) * grams;
          status = before >= goldG ? 'gold' : (before >= silberG ? 'silber' : 'braun');
        }
        var q = n === 1 ? first : quoteFor(grams, pcts[status]);
        totalAll += (q.listCents - q.aboCents) + Math.max(0, onetimeShip - q.shipCents);
      }
      var euros = Math.floor(totalAll / 100);

      return '<p class="kult-qty-finder__club-title">Im Kult-Abo alle 4 Wochen: <strong>' + kgLabel(grams) + '</strong></p>' +
        '<p class="kult-qty-finder__club-row">' + formatPrice(first.aboCents) + ' je Lieferung' +
          (first.shipCents ? ' + ' + formatPrice(first.shipCents) + ' Versand' : ', versandfrei') + '</p>' +
        (member ? '<p class="kult-qty-finder__club-row">mit Kult Status ' + statusLabels[startStatus] + ' (−' + pcts[startStatus] + ' %)</p>' : '') +
        (euros > 0 ? '<p class="kult-qty-finder__club-savings">Du sparst ca. ' + euros.toLocaleString('de-DE') + ' € im Jahr gegenüber dem Einzelkauf</p>' : '');
    }

    function update() {
      if (!cupsInput || !methodSelect) return;
      var cups = parseInt(cupsInput.value, 10) || 1;
      if (cupsOut) cupsOut.textContent = cups;
      var gramsPerUnit = parseInt(methodSelect.value, 10) || 15;
      var gramsPerMonth = cups * gramsPerUnit * 30;

      if (resultEl) {
        resultEl.innerHTML = '<div class="kult-qty-finder__result-value">' + gramsPerMonth.toLocaleString('de-DE') + ' g <span>im Monat</span></div>' +
          '<div class="kult-qty-finder__result-sub">bei ' + cups + (cups === 1 ? ' Tasse' : ' Tassen') + ' à ' + gramsPerUnit + ' g</div>';
      }
      if (clubEl) {
        var card = renderClub(gramsPerMonth);
        clubEl.innerHTML = (card ? '<div class="kult-qty-finder__club">' + card + '</div>' : '') +
          '<p class="kult-qty-finder__onetime">Einzelkauf: ' + packagingRecommendation(gramsPerMonth) + '</p>' +
          (card ? '<p class="kult-qty-finder__club-note">Richtwert, Rabatte rechnet die Kasse.</p>' : '');
      }
    }
    root._kultQtyFinderUpdate = update;

    function onDocClick(e) {
      if (!popover.contains(e.target) && e.target !== toggle) closePopover();
    }
    function onKeydown(e) {
      if (e.key === 'Escape') closePopover();
    }
    function openPopover() {
      popover.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      update();
      document.addEventListener('click', onDocClick);
      document.addEventListener('keydown', onKeydown);
    }
    function closePopover() {
      popover.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', onDocClick);
      document.removeEventListener('keydown', onKeydown);
    }

    toggle.addEventListener('click', function () {
      if (popover.classList.contains('is-open')) closePopover();
      else openPopover();
    });
    if (cupsInput) cupsInput.addEventListener('input', update);
    if (methodSelect) methodSelect.addEventListener('change', update);
  }

  if (!customElements.get('kult-pdp-buybox')) {
    customElements.define('kult-pdp-buybox', class KultPdpBuybox extends HTMLElement {
      connectedCallback() {
        if (this._kultInitialized) return;
        this._kultInitialized = true;
        initBuybox(this);
      }
    });
  }

  /**
   * <kult-pdp-prep>: Tabs/Panels der Zubereitungs-Section. Hört auf das von
   * der Buybox gesendete "kult:pdp:grind"-Event und aktiviert den passenden
   * Tab (kein Scroll). Tabs bleiben zusätzlich manuell klickbar. Panelwechsel
   * per opacity-Transition (200 ms), siehe assets/kult-pdp.css. ARIA-Tabs nach
   * WAI-ARIA APG (automatische Aktivierung): Roving Tabindex, Pfeiltasten
   * links/rechts mit Umlauf, Home/End, Enter/Space; Fokus folgt der Pfeiltaste.
   */
  function initPrep(root) {
    var tabs = root.querySelectorAll('[data-prep-tab]');
    var panels = root.querySelectorAll('[data-prep-panel]');
    if (!panels.length) return;

    function activate(method) {
      var exists = false;
      panels.forEach(function (panel) {
        if (panel.getAttribute('data-prep-panel') === method) exists = true;
      });
      if (!exists) return;

      tabs.forEach(function (tab) {
        var match = tab.getAttribute('data-prep-tab') === method;
        tab.classList.toggle('is-active', match);
        tab.setAttribute('aria-selected', match ? 'true' : 'false');
        tab.setAttribute('tabindex', match ? '0' : '-1');
      });

      panels.forEach(function (panel) {
        var match = panel.getAttribute('data-prep-panel') === method;
        if (match) {
          panel.hidden = false;
          panel.classList.remove('is-active');
          void panel.offsetWidth;
          panel.classList.add('is-active');
        } else if (!panel.hidden) {
          panel.classList.remove('is-active');
          window.setTimeout(function () {
            if (!panel.classList.contains('is-active')) panel.hidden = true;
          }, 200);
        }
      });
    }

    var tabList = Array.prototype.slice.call(tabs);

    tabList.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-prep-tab'));
      });

      tab.addEventListener('keydown', function (e) {
        var currentIndex = tabList.indexOf(tab);
        var targetIndex = null;

        if (e.key === 'ArrowRight') {
          targetIndex = (currentIndex + 1) % tabList.length;
        } else if (e.key === 'ArrowLeft') {
          targetIndex = (currentIndex - 1 + tabList.length) % tabList.length;
        } else if (e.key === 'Home') {
          targetIndex = 0;
        } else if (e.key === 'End') {
          targetIndex = tabList.length - 1;
        } else if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          activate(tab.getAttribute('data-prep-tab'));
          return;
        } else {
          return;
        }

        e.preventDefault();
        var targetTab = tabList[targetIndex];
        activate(targetTab.getAttribute('data-prep-tab'));
        targetTab.focus();
      });
    });

    document.addEventListener('kult:pdp:grind', function (e) {
      var method = e.detail && e.detail.method;
      if (!method) return;
      activate(method);
    });
  }

  if (!customElements.get('kult-pdp-prep')) {
    customElements.define('kult-pdp-prep', class KultPdpPrep extends HTMLElement {
      connectedCallback() {
        if (this._kultInitialized) return;
        this._kultInitialized = true;
        initPrep(this);
      }
    });
  }

  /**
   * <kult-pdp-crosssell>: "Das passt zu deinem Kaffee". Klick auf
   * [data-crosssell-add] legt die Variante per /cart/add.js ab (kein
   * Redirect, Cart-Drawer folgt in Paket 3). Erfolg: Button zeigt 1,5 s
   * "Im Warenkorb". Fehler: role="alert"-Zeile unter der Karte.
   */
  function initCrosssell(root) {
    root.querySelectorAll('[data-crosssell-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;

        var variantId = parseInt(btn.getAttribute('data-crosssell-add'), 10);
        var originalLabel = btn.textContent;
        var card = btn.closest('.kult-crosssell-card');
        var alertEl = card ? card.querySelector('.kult-crosssell-card__alert') : null;

        btn.disabled = true;
        btn.textContent = 'Wird hinzugefügt…';
        if (alertEl) { alertEl.hidden = true; alertEl.textContent = ''; }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (data) {
                throw new Error((data && data.description) || 'Der Artikel konnte nicht hinzugefügt werden.');
              });
            }
            return res.json();
          })
          .then(function (added) {
            btn.textContent = 'Im Warenkorb';
            var title = (added && added.items && added.items[0] && added.items[0].product_title) || (added && added.product_title) || '';
            return fetch('/cart.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                document.dispatchEvent(new CustomEvent('kult:cart:add', { detail: { cart: cart, title: title } }));
                window.setTimeout(function () {
                  btn.disabled = false;
                  btn.textContent = originalLabel;
                }, 1500);
              });
          })
          .catch(function (err) {
            btn.disabled = false;
            btn.textContent = originalLabel;
            if (alertEl) {
              alertEl.hidden = false;
              alertEl.textContent = err.message || 'Es ist ein Fehler aufgetreten.';
            }
          });
      });
    });
  }

  if (!customElements.get('kult-pdp-crosssell')) {
    customElements.define('kult-pdp-crosssell', class KultPdpCrosssell extends HTMLElement {
      connectedCallback() {
        if (this._kultInitialized) return;
        this._kultInitialized = true;
        initCrosssell(this);
      }
    });
  }
})();
